export const SEGMENTS = {
  aquecimento: {
    id: 'aquecimento',
    label: 'Aquecimento',
    hint: '5–10 min: mobilidade, cardio leve, exercícios dinâmicos.',
    order: 1,
  },
  alongamento: {
    id: 'alongamento',
    label: 'Alongamento',
    hint: 'Alongamentos estáticos ou dinâmicos nos grupos do treino.',
    order: 2,
  },
  treino_principal: {
    id: 'treino_principal',
    label: 'Treino principal',
    hint: 'Bloco central: força, hipertrofia ou cardio conforme o objetivo.',
    order: 3,
    required: true,
  },
  desaquecimento: {
    id: 'desaquecimento',
    label: 'Desaquecimento',
    hint: '5–8 min: caminhada leve, alongamentos e respiração.',
    order: 4,
  },
};

export const SEGMENT_ORDER = ['aquecimento', 'alongamento', 'treino_principal', 'desaquecimento'];

export const LEGACY_DEFAULT_COMPOSITION = ['aquecimento', 'treino_principal', 'desaquecimento'];

export const DEFAULT_COMPOSITION = ['treino_principal'];

export function isLegacyFullComposition(arr) {
  if (!Array.isArray(arr) || arr.length !== 3) return false;
  const set = new Set(arr.map((s) => String(s).trim()));
  return LEGACY_DEFAULT_COMPOSITION.every((id) => set.has(id));
}

export function normalizeComposition(selected) {
  const arr = Array.isArray(selected) ? selected : [];
  if (!arr.length) return [...DEFAULT_COMPOSITION];
  const out = SEGMENT_ORDER.filter((id) => arr.includes(id));
  if (!out.includes('treino_principal')) out.push('treino_principal');
  return out.sort((a, b) => SEGMENTS[a].order - SEGMENTS[b].order);
}

export function hydrateCompositionFromDraft(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return [...DEFAULT_COMPOSITION];
  const norm = normalizeComposition(raw);
  if (isLegacyFullComposition(norm)) return [...DEFAULT_COMPOSITION];
  return norm;
}

export function compositionsEqual(a, b) {
  const na = normalizeComposition(a);
  const nb = normalizeComposition(b);
  if (na.length !== nb.length) return false;
  return na.every((id, i) => id === nb[i]);
}
